import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { Row, Form, Col, Button } from 'reactstrap';

import Modal from 'components/Modal/DefaultModal';
import FlexSelect from 'components/Inputs/FlexSelect';

import CustomerPortfolioService from '../../service';
import { toast } from 'react-toastify';

const ChangeAccountCustomerPortfolio = ({
  isCustomerPortfolioOpenModal,
  toggleCustomerPortfolioModel,
  idResource,
  currentCustomerPortfolioId,
  handleGetAccountsFromCustomerPortfolio,
  setSelectedRows
}) => {
  const { control, handleSubmit, errors, setValue } = useForm();
  const [customerPortfolios, setCustomerPortfolios] = useState([]);

  useEffect(() => {
    if (isCustomerPortfolioOpenModal) {
      CustomerPortfolioService.getWithoutPagination()
        .then((response) => {
          const data = response.data.data.content
            .filter((item) => item.id !== currentCustomerPortfolioId)
            .map((item) => ({
              name: item.name,
              id: item.id
            }));

          setCustomerPortfolios(data);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar categoria dos clientes'
          );
        });
    }
  }, [currentCustomerPortfolioId, isCustomerPortfolioOpenModal]);

  const onSubmit = (data) => {
    const userLogin = localStorage.getItem('login');
    if (idResource.length === 0) {
      toast.error('Selecione pelo menos uma conta');
      return;
    }
    CustomerPortfolioService.updateMultipleAccountsWithANewPortfolio(
      data.customerPortfolioId,
      { accountIds: idResource },
      userLogin
    )
      .then(() => {
        toast.success('Categoria do cliente atualizada com sucesso');
        handleGetAccountsFromCustomerPortfolio(1);
        toggleCustomerPortfolioModel(false);
        setSelectedRows([]);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            err.message ||
            'Erro ao atualizar categoria do cliente'
        );
      });
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <Modal
      show={isCustomerPortfolioOpenModal}
      onModalToggle={(state) => toggleCustomerPortfolioModel(state)}
      title="Trocar a categoria dessa(s) conta(s)"
      showCloseButton={false}
    >
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col sm="12" className="mt-2">
            <label className="form-control-label">Categoria do Cliente</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={customerPortfolios || []}
                  isMulti={false}
                  value={props.value}
                  valueController={setValue}
                  fieldName="customerPortfolioId"
                  labelName="name"
                  valueName="id"
                  isClearable={true}
                  placeholder="Selecione uma categoria"
                  closeMenuOnSelect={true}
                />
              )}
              control={control}
              name="customerPortfolioId"
              defaultValue=""
              rules={{ required: 'Campo obrigatório' }}
            />
            <ErrorMessage
              errors={errors}
              name="recordTypeIds"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
        </Row>
        <Button color="primary" type="submit">
          Salvar
        </Button>
      </Form>
    </Modal>
  );
};

export default ChangeAccountCustomerPortfolio;
